import {
  List,
  Datagrid,
  EmailField,
  TextField,
  BooleanField,
  ChipField,
  NumberField,
  DateField,
  Show,
  SimpleShowLayout,
  useNotify,
  Toolbar,
  SaveButton,
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin'

import { inviteUser } from '../dataProvider'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserList = () => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick="show">
      <EmailField source="email" />
      <BooleanField source="isEmailVerified" />
      <ChipField source="role" />
      <BooleanField source="isMFARequired" />
      <NumberField source="acceptedTermsAndPolicyVersion" />
      <DateField source="lastAuthenticatedAt" />
      <ChipField source="registeredWith" />
      <DateField source="verificationEmailSentAt" />
      <TextField source="invitedBy" />
    </Datagrid>
  </List>
)

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <EmailField source="email" />
      <BooleanField source="isEmailVerified" />
      <ChipField source="role" />
      <BooleanField source="isMFARequired" />
      <NumberField source="acceptedTermsAndPolicyVersion" />
      <DateField source="lastAuthenticatedAt" />
      <ChipField source="registeredWith" />
      <DateField source="verificationEmailSentAt" />
      <TextField source="invitedBy" />
    </SimpleShowLayout>
  </Show>
)

const InviteToolbar = () => {
  return (
    <Toolbar>
      <SaveButton label="Invite User" />
    </Toolbar>
  )
}

export const UserInvite = () => {
  const notify = useNotify()
  const onInvite = async (params) => {
    await inviteUser(params)

    notify('User will receive invitation on the email.')
  }

  return (
    <Create>
      <SimpleForm toolbar={<InviteToolbar />} onSubmit={onInvite}>
        <TextInput source="email" type="email" />
        <SelectInput
          source="role"
          choices={[
            { id: 'ADMIN', name: 'Admin' },
            { id: 'USER', name: 'User' },
          ]}
        />
      </SimpleForm>
    </Create>
  )
}